<svg #circle xmlns="https://www.w3.org/2000/svg" viewBox="0 0 100 100" role="img" aria-label="Colored circle">
  <title>Colored circle</title>
  <circle [ngClass]="{'active': active}" cx="50" cy="50" r="50" fill="#C4C4C4"/>
</svg>
